<template>
	<div class="projectDetail-container">
		<div v-loading="loading" class="project-detail-content">
			<!-- 详情-表格数据 -->
			<div class="common-detail-table">
				<table>
					<colgroup>
						<col width="180" />
						<col />
						<col width="180" />
						<col />
					</colgroup>
					<tr>
						<th>项目名称</th>
						<td>{{ contractRegisterDetail.projectName }}</td>
						<th>工程名称</th>
						<td>{{ contractRegisterDetail.engineeringName }}</td>
					</tr>
					<tr>
						<th>所在地市</th>
						<td>{{ contractRegisterDetail.cityName }}</td>
						<th>所在区县</th>
						<td>{{ contractRegisterDetail.countyName }}</td>
					</tr>
					<tr>
						<th>合同登记编号</th>
						<td>{{ contractRegisterDetail.contractRegisterNumber }}</td>
						<th>合同编号</th>
						<td>{{ contractRegisterDetail.contractNumber }}</td>
					</tr>
					<tr>
						<th>中标通知书编号</th>
						<td>{{ contractRegisterDetail.contractNoticeNumber }}</td>
						<th>合同类别</th>
						<td>{{ contractRegisterDetail.contractTypeName }}</td>
					</tr>
					<tr>
						<th>合同签订日期</th>
						<td>{{ contractRegisterDetail.contractSignDate }}</td>
						<th>建设规模</th>
						<td>{{ contractRegisterDetail.designScale }}</td>
					</tr>
					<tr>
						<th>合同金额(万元)</th>
						<td>{{ contractRegisterDetail.contractMoney }}</td>
						<th></th>
						<td></td>
					</tr>
					<tr>
						<th>发包单位名称</th>
						<td>{{ contractRegisterDetail.subcontractingUnitName }}</td>
						<th>发包单位唯一编码</th>
						<td>{{ contractRegisterDetail.subcontractingUnitCode }}</td>
					</tr>
					<tr>
						<th>联合体承包单位名称</th>
						<td>{{ contractRegisterDetail.consortiumContractorName }}</td>
						<th>联合体承包单位唯一编码</th>
						<td>{{ contractRegisterDetail.consortiumContractorCode }}</td>
					</tr>
					<tr>
						<th>记录登记时间</th>
						<td>{{ contractRegisterDetail.registerTime }}</td>
						<th></th>
						<td></td>
					</tr>
				</table>
			</div>
		</div>
		<!-- 未开通会员提示 -->
		<nonbind-vip v-if="noNumber" :messageInfo="message"></nonbind-vip>
	</div>
</template>

<script>
	import NonbindVip from '@/components/NonBind/nonbindVip.vue'
	import { transObject } from '@/utils/index'
	import { getContractRegisterDetail } from '@/api/qualificationQuery/project'

	// 合同登记信息详情
	export default {
		name: 'ContractInformation',
		components: { NonbindVip },
		props: {
			id: {
				type: String,
				required: true,
				default: ''
			}
		},
		data() {
			return {
				// 数据加载状态
				loading: false,
				noNumber: false,
				// 合同登记信息详情
				contractRegisterDetail: {
					// 项目名称
					projectName: '',
					// 工程名称
					engineeringName: '',
					// 所在地市
					cityCode: '',
					cityName: '',
					// 所在区县
					countyCode: '',
					countyName: '',
					// 合同登记编号
					contractRegisterNumber: '',
					// 合同编号
					contractNumber: '',
					// 中标通知书编号
					contractNoticeNumber: '',
					// 合同类别
					contractType: '',
					contractTypeName: '',
					// 合同签订日期
					contractSignDate: '',
					// 建设规模
					designScale: '',
					// 合同金额
					contractMoney: '',
					// 发包单位名称
					subcontractingUnitName: '',
					// 发包单位唯一代码
					subcontractingUnitCode: '',
					// 承包单位名称
					contractorUnitName: '',
					// 承包单位唯一编码
					contractorUnitCode: '',
					// 联合体承包单位名称
					consortiumContractorName: '',
					// 联合体承包单位唯一代码
					consortiumContractorCode: '',
					// 记录登记时间
					registerTime: ''
				},
				message: ''
			}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.handleQueryContractRegisterDetail()
		},
		methods: {
			// 查询合同登记详情
			handleQueryContractRegisterDetail() {
				this.loading = true
				const params = {
					contractRegisterId: this.id
				}

				getContractRegisterDetail(params)
					.then(response => {
						const { data, code, message } = response

						if (String(code).startsWith('6')) {
							this.noNumber = true
							this.message = message
						} else {
							if (data) {
								// 将目标数据转为我指定的属性对象
								transObject(data, this.contractRegisterDetail)
							}
						}
						this.loading = false
					})
					.catch(error => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/table.scss';
	@import '../../styles/project.scss';
</style>
